// import { firebase, googleAuthProvider } from '../firebase/firebase';
// import axios from 'axios';
// import isEmpty  from 'lodash/isEmpty';
// import { history }  from '../routers/AppRouter'
import {picAppError, clearPicAppError } from './picapp';
import getAppConfigParm  from '../config/AppConfig';
// import { dispatch } from 'react-redux';


// Action creator to intialize the contact list
export const initializeContacts = (list) => ({
    type: 'INITIALIZE_CONTACTS',
    list
});

// Action creator to delete contacts from redux store 
export const startDeleteContacts = (deleteList = []) => {
    return (dispatch, getState ) => {
        /* make copy of contacts */
        let contactsCopy = [...getState().contacts.list];
        /* loop through each emailAddr in deleteList and delete from contacts copy */
        let foundIndex = '';
        deleteList.forEach((emailAddr) => {
            function matchesEmail (contact) {
                return contact.email === emailAddr;
            }
            foundIndex = contactsCopy.findIndex(matchesEmail);
            foundIndex !== -1 && contactsCopy.splice(foundIndex, 1);
        });
        /* dispatch action to update redux/local storage with modified copy of contacts array */
        dispatch(updateContacts(contactsCopy));
    }
};

export const updateContacts = (list) => {
    return {
        type: 'UPDATE_CONTACTS',
        list
    }
};




// WEBPACK FOOTER //
// ./src/actions/contacts.js